module.exports = __webpack_public_path__ + "d038b7ed641db07b673b255136b21993.svg";